export function createMatchPattern(textToMatch: string) {
  if (textToMatch.trim().length === 0) {
    return new RegExp('[]^', 'i')
  }
  const escapedText = textToMatch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const pattern = `^\\s*${escapedText.split(/\s+/).join('\\s+')}\\s*$`

  return new RegExp(pattern, 'i')
}
